module.exports = __webpack_public_path__ + "img/brice.f4dc6404.jpg";